// src/MagicLogin.js
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import API from './api';

const MagicLogin = () => {
  const [status, setStatus] = useState('Verifying your secure link...');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const rawToken = params.get('token');

    if (!rawToken) {
      setError('Missing or invalid login token.');
      setStatus('');
      return;
    }

    const doLogin = async (lat, lon) => {
      try {
        setStatus('Signing you in...');
        const payload = { token: rawToken };
        if (lat != null && lon != null) {
          payload.latitude = lat;
          payload.longitude = lon;
        }

        const res = await API.post('/auth/magic-login', payload);
        const { token, user } = res.data || {};

        if (!token || !user) {
          throw new Error('Invalid server response');
        }

        // Auth kao u /login
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(user));

        // Location za ProtectedRoute (čak i kad je dummy)
        const loc = {
          lat: lat ?? null,
          lon: lon ?? null,
          ts: new Date().toISOString(),
          source:
            lat != null && lon != null
              ? 'magic-login'
              : 'magic-login-no-geo',
        };
        localStorage.setItem('location', JSON.stringify(loc));

        // Redirect po roli
        if (user.role === 'admin') {
          navigate('/admin', { replace: true });
        } else if (user.role === 'teacher') {
          navigate('/teacher', { replace: true });
        } else {
          navigate('/login', { replace: true });
        }
      } catch (err) {
        console.error('Magic login error', err);
        const apiMsg = err?.response?.data?.error;
        setError(apiMsg || 'This login link is invalid, used, or expired.');
        setStatus('');
      }
    };

    // Pokušaj geolokacije, onda BE poziv
    setStatus('Checking your link & location...');
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          const lat = pos.coords.latitude;
          const lon = pos.coords.longitude;
          doLogin(lat, lon);
        },
        () => {
          doLogin(null, null);
        },
        { timeout: 8000 }
      );
    } else {
      doLogin(null, null);
    }
  }, [location.search, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100 px-4">
      <div className="bg-white shadow-md rounded-xl p-6 max-w-sm w-full text-center">
        <h1 className="text-xl font-semibold mb-2 text-slate-800">
          Secure login via magic link
        </h1>

        {status && !error && (
          <p className="text-sm text-slate-600 mb-2">
            {status}
          </p>
        )}

        {!error && (
          <p className="text-[11px] text-slate-400 mt-3">
            Please keep this window open while we verify your link.
            This link is single-use and time-limited.
          </p>
        )}

        {error && (
          <>
            <p className="text-sm text-red-600 mb-3">
              {error}
            </p>
            <button
              onClick={() => navigate('/login', { replace: true })}
              className="mt-1 inline-flex items-center justify-center px-4 py-2 bg-sky-600 text-white text-sm rounded-lg"
            >
              Go to Login
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default MagicLogin;
